import { render, staticRenderFns } from "./DetailBank.vue?vue&type=template&id=74e61e46"
import script from "./DetailBank.vue?vue&type=script&lang=js"
export * from "./DetailBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports